import * as _4 from 'lodash4';

export type TAPIAlertReason = Record<string | number, string>;

export class SelfAlertReason {
  id: string | number;
  reason: string;

  constructor(apiAlertReason: SelfAlertReason) {
    _4.merge(this, apiAlertReason);
  }

  static build(apiAlertReason: SelfAlertReason): SelfAlertReason {
    return new SelfAlertReason(apiAlertReason);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/builders/self_alert_reason_builder.ts